import React from 'react';
import Skeleton from '../components/skeleton/List';
import '../assets/css/list.scss';
import '../assets/css/list-panel.scss';
import Refresh_icon from '../assets/img/refresh.svg';
import ErrorHandler from '../class/ErrorHandler';
import commonMethod from '../lib/commonMethod';
import PinIcon from '../assets/img/list/pin';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import constants from '../lib/constants/constants';
import Refresh from '../components/Refresh';
class List extends React.Component {
  constructor(props) {
    super(props);
    // test
    this.state = {
      loading: true,
      shopList: null,
      accessToken: null,
      refresh: false,
      username: null
    };
    this.errorHandler = new ErrorHandler(this);
    this.accessToken = cookie.load('accessToken');
  }

  componentDidMount() {
    //무한루프 이슈 해결
    if (localStorage.getItem('accessToken') && !cookie.load('accessToken')) {
      let accessToken = JSON.parse(localStorage.getItem('accessToken'));
      cookie.save('accessToken', accessToken.value, { path: '/' });
    }
    if (localStorage.getItem('username') && !cookie.load('username')) {
      cookie.save('username', localStorage.getItem('username'), { path: '/' });
    }
    if (!cookie.load('accessToken')) {
      // accessToken이 빈 경우 code값 받아 token API 호출
      const code = commonMethod.getQueryString('code');
      const data = {
        grant_type: 'authorization_code',
        code: code,
        client_id: '62f4020744ca4510827d3b4a4d2c7e7f',
        redirect_uri: window.location.origin + '/list'
      };
      commonMethod.requestPost(
        'oauth/token',
        data,
        res => {
          const { access_token } = res;
          this.getShopList(access_token);
          cookie.save('accessToken', access_token, { path: '/' });
          this.accessToken = access_token;
          this.getUserInfo(access_token);

          if (!cookie.load('username')) {
            //username이 없을시 로그인 페이지로
            window.location.href = constants.URL.LOGIN;
          }
          // 자동로그인인 경우 token 값 localStorage에 담음
          if (cookie.load('autoLogin')) {
            const accessToken = {
              value: access_token,
              timestamp: new Date().getTime()
            };
            localStorage.setItem('accessToken', JSON.stringify(accessToken));
            localStorage.setItem('username', cookie.load('username'));
          }
        },
        () => (window.location.href = constants.URL.LOGIN)
      );
    } else {
      this.getShopList(cookie.load('accessToken'));
    }
  }

  componentDidUpdate() {
    if (this.props.isRefresh) {
      this.setState({ refresh: true });
      this.getShopList(this.accessToken);
      this.props.setIsRefresh(false);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(
      nextState.shopList === this.state.shopList &&
      nextProps.userName === this.props.userName &&
      nextState.refresh === this.state.refresh &&
      nextProps.isRefresh === this.props.isRefresh
    );
  }

  getUserInfo(accessToken) {
    // 유저정보 get
    commonMethod.requestGetWithToken(
      'dashboard/config/user',
      accessToken,
      this,
      res => {
        this.props.setUserName(res.member[0].name);
        this.setState((state /* props */) => {
          return { username: state.username };
        });
      }
    );
  }

  getShopList(accessToken) {
    // 샵리스트 get
    commonMethod.requestGetWithToken(
      'dashboard/family',
      accessToken,
      this,
      res => {
        let shopList = [];
        if (res.result && res.result.length > 0) shopList = res.result;
        this.setState({ loading: false, shopList: shopList, refresh: false });
      },
      () => this.setState({ loading: false, shopList: null, refresh: false })
    );
  }

  moveDashboard(familyId) {
    // 대시보드 페이지로 이동
    window.location.href = constants.URL.DASHBOARD;
    cookie.save('familyId', familyId, { path: '/' });
  }

  render() {
    let shopList = this.state.shopList;
    return (
      <div id="shop-list" className="page">
        {this.state.loading ? (
          <Skeleton />
        ) : this.state.shopList && this.state.shopList.length > 0 ? (
          // 리스트
          <div className="wrap">
            <h2>
              안녕하세요{' '}
              {this.props.userName ? this.props.userName : this.state.username}
              님
            </h2>
            <p>헤이홈 for Web에 오신것을 환영해요 :)</p>
            <ul>
              {shopList &&
                shopList.length > 0 &&
                shopList.map(v => {
                  return (
                    <li
                      key={v.familyId}
                      onClick={() => this.moveDashboard(v.familyId)}
                    >
                      <button className="middle">
                        <div>
                          <PinIcon />
                          <span>{v.name}</span>
                        </div>
                      </button>
                    </li>
                  );
                })}
            </ul>
            {/* 새로고침 */}
            {this.state.refresh && <Refresh />}
          </div>
        ) : (
          // 에러
          <div className="refresh-box">
            <img src={Refresh_icon} alt="" />
            <p>
              <strong>샵 정보를 가져오지 못했어요.</strong>
              <br />
              네트워크 연결 상태를 확인하여 주시거나 헤이홈 앱에서
              <br />
              장소를 생성한 후 새로고침 해주세요.
            </p>
            <button className="btn active" onClick={() => this.getShopList()}>
              새로고침
            </button>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    accessToken: state.hejhome.accessToken,
    userName: state.hejhome.userName,
    isRefresh: state.hejhome.isRefresh
  };
}

// dispatch - set
const mapDispatchToProps = dispatch => ({
  setAccessToken: token =>
    dispatch({
      type: 'setAccessToken',
      accessToken: token
    }),
  setUserName: name =>
    dispatch({
      type: 'setUserName',
      userName: name
    }),
  setIsRefresh: bool =>
    dispatch({
      type: 'setIsRefresh',
      isRefresh: bool
    })
});

List = connect(mapStateToProps, mapDispatchToProps)(List);

export default List;
